import React from "react";
import { Layout } from "antd";
import "../App.css";
import NavBar from "../components/Header";
import KakiKaki from "../components/Footer";
import CardContent from "../components/CardContent";
import RentalList from "../components/explore/RentalList";
import { Switch, Route,Router } from "react-router-dom";
import app from "../base"
import DetailRentalCard from "../components/explore/DetailRental";

const { Header, Footer, Content } = Layout;

class ExplorePage extends React.Component {
  constructor(props) {
    super(props);
    this.ref = app.firestore().collection("rentals");
    this.unsubscribe = null;
    this.state = {
      rentals: [],
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const rentals = [];
    querySnapshot.forEach((doc) => {
      const {
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      } = doc.data();
      rentals.push({
        key: doc.id,
        doc, // DocumentSnapshot
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      });
    });
    this.setState({
      rentals,
    });
  };
  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }
  render() {
    return (
      <Layout>
        <Header>
          <NavBar />
        </Header>
        <Content>
          <Switch>
            <Route exact path="/explore">
              <RentalList />
            </Route>

            <Route
              path="/explore/:id"
              render={(props) => <DetailRentalCard {...props} />}
              component={DetailRentalCard}
            >
                <DetailRentalCard/>
            </Route>
          </Switch>
        </Content>
        <Footer style={{ background: "#7F7CAF" }}>
          <KakiKaki />
        </Footer>
      </Layout>
    );
  }
}

export default ExplorePage;
